import type { LeafClassification } from '../api';

export const getLeafId = (classification: LeafClassification): string =>
    (classification.nested_sub_category_id || classification.sub_category_id).toString();

export * from './retryWrapper';
export * from './convertDollarToCents';
export * from './normalizeLineEndings';
export * from './buildUrlWithFromApp';
